import { normalizedConversationPhone } from "./conversationIdentity.mjs";
import { resolveVendasSourceRecord } from "./newUi/vendasModel.mjs";

const modules = {
  leads:"leads",
  arflow_clients:"kanban",
  arflow_prospeccao:"prospeccao",
  arflow_indicacoes:"indicacoes",
};

// A contact found during the create request is reused, not a new client card.
export function isLiftRegisteredClientCard(client) {
  return client?.sourceLink?.rootName === "arflow_clients";
}

function canonicalPhone(value) {
  let phone = normalizedConversationPhone(value);
  if (phone.length === 10) phone = `${phone.slice(0, 2)}9${phone.slice(2)}`;
  return phone;
}

// A sale's origin label or phone alone is never a conversation identity.
export function liftCrmSourceRoute(sourceLink, options = {}) {
  const moduleId = modules[sourceLink?.rootName];
  const storeId = Number(sourceLink?.storeId);
  const key = String(sourceLink?.key || "");
  const phone = sourceLink?.phone;
  const user = options.currentUser || {};
  if (!["consultant", "manager", "admin", "superadmin"].includes(user.role)) return null;
  if (!moduleId || !key || !storeId || !canonicalPhone(phone)) return null;
  if (["consultant", "manager"].includes(user.role) && Number(user.storeId) !== storeId) return null;
  if (moduleId === "indicacoes") {
    // The indications view rechecks the exact key against its authorized list.
    return { moduleId, storeId, phone, recordId:key, key };
  }
  const records = moduleId === "leads" ? options.leads
    : moduleId === "prospeccao" ? options.prospeccao : options.clients;
  const matches = (records || []).filter(record => {
    const keys = [record.id, record.key, record._firebaseKey, record._rawPhone]
      .filter(value => value != null).map(String);
    if (String(record.id || "").startsWith("aurora_")) keys.push(String(record.id).slice(7));
    return keys.includes(key)
      && Number(record.lojaAtual ?? record.storeId) === storeId
      && canonicalPhone(record.telefone || record.phone) === canonicalPhone(phone);
  });
  if (matches.length !== 1) return null;
  const record = matches[0];
  const route = {
    moduleId, storeId, phone:record.telefone || record.phone,
    recordId:String(record.id),
  };
  return resolveVendasSourceRecord(route, options) ? route : null;
}